module.exports = __webpack_public_path__ + "img/play.cc55729f.png";